import { Download, Upload, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ROUTE } from '@/config';
import { ExportModal } from './ExportModal/ExportModal';
import { useNavigate } from 'react-router-dom';
import usePermission from '@/hooks/usePermission';
import useOrdersPaused from '@/hooks/useOrdersPaused';
import { PermissionName } from '@/types';
import { selectOpenExport, useExportModalStore } from '@/stores/useExportModalStore';

const OrderPageHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hasPermission } = usePermission();
  const ordersPaused = useOrdersPaused();
  // BOXY-409 — the same modal the bottom bar's Export opens.
  const openExport = useExportModalStore(selectOpenExport);

  const iconBtnClass =
    'w-9 h-9 flex items-center justify-center rounded-xl border border-solid transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:bg-black/[0.04]';

  return (
    <div className='flex items-center gap-2'>
      <button
        onClick={openExport}
        disabled={!hasPermission(PermissionName.ORDER_AND_SHIPMENT)}
        className={iconBtnClass}
        style={{ borderColor: 'rgb(232, 230, 227)', backgroundColor: '#ffffff' }}
        title={String(t('export'))}
      >
        <Upload className='w-[18px] h-[18px]' style={{ color: 'rgb(115, 123, 140)' }} strokeWidth={1.5} />
      </button>
      <button
        onClick={() => navigate(ROUTE.IMPORT)}
        disabled={!hasPermission(PermissionName.BULK_IMPORT_ORDER) || ordersPaused}
        className={iconBtnClass}
        style={{ borderColor: 'rgb(232, 230, 227)', backgroundColor: '#ffffff' }}
        title={String(t('import'))}
      >
        <Download className='w-[18px] h-[18px]' style={{ color: 'rgb(115, 123, 140)' }} strokeWidth={1.5} />
      </button>
      <button
        onClick={() => navigate(ROUTE.ADDNEWORDER)}
        disabled={!hasPermission(PermissionName.CREATE_ORDER) || ordersPaused}
        className='flex items-center gap-2 h-9 px-4 rounded-lg text-[13px] font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90'
        style={{ backgroundColor: 'rgb(237, 224, 74)', color: 'rgb(57, 57, 60)' }}
      >
        <Plus className='w-4 h-4' strokeWidth={2} />
        {String(t('new_order'))}
      </button>

      <ExportModal />
    </div>
  );
};

export default OrderPageHeader;
